module.exports = __webpack_public_path__ + "img/ambit_logo.a60a3df1.png";